<template>
  <div
    v-if="verification.status.startsWith('VERIFIED')"
    @click.stop="showModal(true)"
    class="rounded-md w-12 h-12 flex items-center justify-center bg-indigo-100 cursor-pointer"
  >
    <div class="text-center scale-75 font-bold text-indigo-600">
      <ShieldCheckIcon class="h-10 w-10" />
    </div>
  </div>
  <div
    v-else-if="verification.status === 'REVIEWED'"
    @click.stop="showModal(false)"
    class="rounded-md w-12 h-12 flex items-center justify-center bg-indigo-100 cursor-pointer"
  >
    <div class="text-center scale-75 font-bold text-indigo-600">
      <CheckCircleIcon class="h-10 w-10" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useModalStore } from '@/stores/modal'
import { ShieldCheckIcon } from '@heroicons/vue/20/solid'
import { format } from 'date-fns'
import VerifiedInfoModal from './VerifiedInfoModal.vue'
import { CheckCircleIcon } from '@heroicons/vue/24/outline'
const { presentModal } = useModalStore()

const props = defineProps<{ verification: { completedAt: string; status: string } }>()

const showModal = (verified: boolean) => {
  presentModal({
    component: VerifiedInfoModal,
    componentProps: {
      status: verified ? 'VERIFIED' : 'REVIEWED',
      title: `${verified ? 'Verified' : 'Reviewed'} by Crewdentials on ${format(new Date(props.verification.completedAt), 'do MMM yyyy')}`,
      message: verified
        ? 'This document has been verified with the issuer by a member of our team.'
        : 'This document has been checked by a member of our team and the document type, dates and issuer are profiled correctly.  The document has not been verified with the issuer.'
    }
  })
}

defineExpose({ showModal })
</script>
